import { AB_TRUECALLER } from 'constants/experiments';
import { getEligibleForVariant } from 'helpers/experimentV2';
import { useSelector } from 'react-redux';
import { State } from 'shared/store/types';

export const useIsLoggedIn = (): boolean => {
  const isLoggedIn = useSelector((state: State) => {
    const { auth } = state;
    return auth.dataFetched && !!auth.user.email;
  });

  return isLoggedIn;
};

export const useUserData = () => {
  const user = useSelector((state: State) => {
    const { auth } = state;
    return auth.user;
  });

  return user;
};

export const useTruecallerStatus = () => {
  const device = useSelector(
    (state: State) => state.appReducer?.client?.device
  );

  const trueCallerConfig = useSelector(
    (state: State) => state.remoteConfig?.configs?.trueCaller
  );

  const isTrueCallerEnabled = useSelector((state: State) =>
    getEligibleForVariant(state, AB_TRUECALLER, 'A')
  );

  const isStatusFetching = useSelector(
    (state: State) => state?.appReducer.isTruecallerStatusFetching
  );

  return { device, trueCallerConfig, isTrueCallerEnabled, isStatusFetching };
};
